import { gatewayClient, createService } from './connectors/httpClient';
import { createQuery } from '~/helpers/queryString';

const httpClient = gatewayClient('/creatives');

const creativesService = createService(httpClient, (client) => ({
    fetchCreative(id) {
        return client
            .get<{ data_schema: { properties: Record<string, { displayOrder: number }> } }>(`/${id}`)
            .then(({ json, status }) => {
                return { status, creative: json };
            });
    },

    fetchCreatives(id, opt) {
        const path =
            '?' +
            ('customerId=' + id + '&') +
            createQuery(opt) +
            (opt.creativeType ? '&creativeType=' + opt.creativeType : '') +
            (opt.collectionId ? '&collectionId=' + opt.collectionId : '') +
            (opt.aspectRatio ? '&aspectRatio=' + opt.aspectRatio : '') +
            (opt.ownershipSource ? '&ownershipSource=' + opt.ownershipSource : '') +
            (opt.approvalStatus ? '&approvalStatus=' + opt.approvalStatus : '') +
            (opt.hasPublishedVersion ? '&hasPublishedVersion=' + opt.hasPublishedVersion : '') +
            (opt.hasOwnProperty('isCorrupted') ? '&isCorrupted=' + opt.isCorrupted : '');

        return client.get<{ items: unknown[]; totalItems: number }>(path).then(({ json, status }) => {
            return { json, creatives: json.items, status };
        });
    },

    deleteCreatives(ids) {
        return client.delete('', { ids });
    },

    renameCreativeOrTemplate(id: number, data: { name: string; description?: string }) {
        return client.put<{ id: string; name: string }>(`/${id}`, data);
    },

    publishCreativeTemplate(creativeId, data) {
        return client.put(`/${creativeId}/editor/publish`, data);
    },

    saveCreativeTemplate(creativeId, data) {
        return client.put(`/v2/${creativeId}/editor`, data, {}, false);
    },
}));

export default creativesService;
